import React, { Component } from 'react'
import { Tag, Button } from 'antd'
import statesQuery from '~/App/graphql/queries/states.gql'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import { FormattedMessage } from 'react-intl'

@graphql(statesQuery, {
  options: () => ({
    variables: { countryName: 'Thailand' }
  }),
  name: 'statesQuery'
})
class DeliveryAddressPreviewBox extends Component {
  render () {
    const { deliveryAddress, locale, customMessage, statesQuery, editabled, handleSelectDeliveryAddress } = this.props
    let daTemp = { ...deliveryAddress }
    Object.entries(daTemp).forEach(([key, value]) => {
      if (value == null) daTemp[key] = ''
    })
    const phone = `${({
      en: `Phone:`,
      zh: `Phone:`,
      th: `เบอร์โทร:`
    })[locale]} ${daTemp.telephone}`
    let state = statesQuery.statesByCountry ? statesQuery.statesByCountry.find(s => s._id === daTemp.province) : daTemp.province
    state = _get(state, `name.th`)
    const province = state || daTemp.province
    const address = ` ${daTemp.street}, ${daTemp.locality}, ${daTemp.city}, ${province}, ${daTemp.postalCode}`
    return <div>
      <div className="deliveryAddressBox" key={deliveryAddress._id}>
        <h1>
          {({
            en: `Deliver address`,
            zh: `Deliver address`,
            th: `ที่อยู่จัดส่ง`
          })[locale]}
          { editabled && <Button icon="edit" onClick={handleSelectDeliveryAddress} className="edit changeDeliveryAddressBtn">
            <FormattedMessage id="app.changeDeliveryAddress"/>
          </Button> }
        </h1>
        {customMessage && <Tag color="orange" className="status">
          {customMessage}
        </Tag>}
        <h4>
          ชื่อผู้รับ: {daTemp.fullname}
        </h4>
        <div>
          {address}
        </div>
        <div>
          {phone}
        </div>
      </div>
    </div>
  }
}

export default DeliveryAddressPreviewBox



// WEBPACK FOOTER //
// ./src/App/components/DeliveryAddressPreviewBox.js